import { render, staticRenderFns } from "./DocumentSecureToolbar.vue?vue&type=template&id=0133dd4e&scoped=true&"
import script from "./DocumentSecureToolbar.vue?vue&type=script&lang=js&"
export * from "./DocumentSecureToolbar.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSecureToolbar.vue?vue&type=style&index=0&id=0133dd4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133dd4e",
  null
  
)

export default component.exports